<div class="wellcome_area">
    <mat-card class="centered mat-elevation-z4">
        <div fxLayout="row" fxLayoutAlign="space-around center">
            <div class="logo" fxLayout="column" fxLayoutAlign="center center">
                <img src="../../assets/img/logo_procesa.png" class="img">
            </div>


            <div class="box-form" fxLayout="column" fxLayoutAlign="center center" [formGroup]="form">


                <div fxLayout="row" fxLayoutAlign="center center">
                    <mat-form-field appearance="outline">
                        <mat-label>Usuario</mat-label>
                        <input matInput formControlName="username" type="text" placeholder="N° documento">
                        <mat-error>
                            <div *ngFor="let e of usuarioErrorsMsg">
                                <span
                                    *ngIf="form.get('username').hasError(e.type) && (form.get('username').dirty || form.get('username').touched)">
                                    {{ e.message }}
                                </span>
                            </div>
                        </mat-error>
                    </mat-form-field>
                </div>
                <br>
                <div fxLayout="row" fxLayoutAlign="center center">
                    <mat-form-field appearance="outline">
                        <mat-label>Contraseña</mat-label>
                        <input matInput formControlName="password" [type]="hideCurrent ? 'password' : 'text'"
                            placeholder="Contraseña" (keyup.enter)="login()">
                        <button mat-icon-button matSuffix (click)="hideCurrent = !hideCurrent"
                            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideCurrent">
                            <mat-icon>{{hideCurrent ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </button>
                        <mat-error>
                            <div *ngFor="let e of passwordErrorsMsg">
                                <span
                                    *ngIf="form.get('password').hasError(e.type) && (form.get('password').dirty || form.get('password').touched)">
                                    {{ e.message }}
                                </span>
                            </div>
                        </mat-error>
                    </mat-form-field>

                </div>
                <div class="forgot-password" fxLayout="row" fxLayoutAlign="end center">
                    <span class="forgot-link" (click)="abrirModalRecuperacion()">
                        ¿Olvidaste tu contraseña?
                    </span>
                </div>

                <br>
                <br>

                <div class="box-button" fxLayout="row" fxLayoutAlign="center center">
                    <button mat-raised-button class="login-button" (click)="login()"
                        [disabled]="form.invalid || inSubmission" [ngClass]="{
                        'login-submit-disable': form.invalid || inSubmission,
                        'spinner-login': inSubmission
                    }">
                        <div class="icon-text">
                            <mat-icon>keyboard_arrow_right</mat-icon>
                            Iniciar sesión
                        </div>
                    </button>


                    <!-- <button [disabled]="inSubmission" 
              [ngClass]="{
                'opacity-50': inSubmission,
                'hover: bg-indigo-700': !inSubmission
              }"
              type="submit" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm rounded-md text-white bg-indigo-600 focus:outline-none">
              Publish
            </button> -->
                </div>
            </div>


        </div>



    </mat-card>
</div>